export const SET_OBJECTS = 'SET_OBJECTS';
export const SET_OBJECT = 'SET_OBJECT';
export const SET_OBJECT_ORDERS = 'SET_OBJECT_ORDERS';
export const SET_OBJECT_BLOCKING = 'SET_OBJECT_BLOCKING';
